export const consts = {
  SCHEMA_ERROR_CODE: 422,
  BAD_REQUEST_CODE: 400,
  NOT_AUTH: 401,
  SUCCESS: 200,
  ENTER_KEY_CODE: "Enter",
};
